<template>
  <v-container id="menús" tag="section">
    <base-v-component heading="Menús del Negocio " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn
          v-if="isAdmin"
          color="success"
          dark
          class="mb-2"
          @click="goAdd()"
          >{{ formTitle }}</v-btn
        >
        <!-- <v-btn
          v-if="isAdmin"
          color="primary"
          dark
          class="mb-2 mx-4"
          @click="goPrecios(item)"
          >PRECIOS <v-icon class="ml-1" small>mdi-currency-eur</v-icon></v-btn
        >-->

        <v-btn
          v-if="!ordenando && isAdmin"
          color="success"
          dark
          class="mx-2 mb-2"
          @click="ordenando = true"
          >Ordenar</v-btn
        >
        <v-btn
          v-if="ordenando && isAdmin"
          color="success"
          dark
          class="mx-2 mb-2"
          @click="ordenando = false"
          >Volver listado</v-btn
        >
        <v-spacer />
        <v-spacer />

        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="menusComputed"
        :loading="loading"
        :search="search"
        v-if="!ordenando && isAdmin"
      >
        <template v-slot:item.imagen="{ item }">
          <v-img
            v-if="item.imagen"
            :src="item.imagen"
            aspect-ratio="2"
            width="135px"
          ></v-img>
          <span v-else>sin imagen</span>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>

            <!-- <v-btn
							v-if="item.individualPedible"
							@click="goLotes(item)"
							class="px-2 ml-1"
							color="secondary"
							min-width="0"
							small
						>
							<v-icon small>mdi-home</v-icon>
						</v-btn> -->
            <v-badge
              :value="!!item.grupoModificador"
              bordered
              color="purple"
              overlap
              left
            >
              <v-btn
                @click="goEdit(item)"
                class="px-2 ml-1"
                color="grey"
                min-width="0"
                small
                depressed
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </v-badge>
            <!-- <v-btn
							@click="duplicar(item)"
							class="px-2 ml-1"
							color="success"
							min-width="0"
							small
						>
							<v-icon small>mdi-content-duplicate</v-icon>
						</v-btn> -->
            <v-btn
              @click="deleteItem(item)"
              class="px-2 ml-1"
              color="red"
              min-width="0"
              small
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </template>
      </v-data-table>
      <v-row v-else-if="isAdmin" align="center" justify="center">
        <v-col cols="6">
          <v-list>
            <draggable v-model="ordenP">
              <div v-for="element in menusOrden" :key="element.id">
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon big>mdi-drag</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>{{
                    mostrarIdioma(element.nombre)
                  }}</v-list-item-content>
                  <v-list-item-action>{{ element.orden }}</v-list-item-action>
                </v-list-item>
              </div>
            </draggable>
          </v-list>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>


<script>
import { mostrarIdioma } from "@/utils/utils.js";
import { storage } from "@/firebase";
import { createSlug } from "@/utils/utils.js";
import { mapState, mapGetters, mapActions } from "vuex";
import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  data() {
    return {
      loading: false,
      loadingForm: false,
      dialogMapeo: false,
      //search: "",
      id: null,
      ordenando: false,
      headersBossNegocio: [
        {
          sortable: false,
          text: "Imagen",
          value: "imagen",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "nombreMostrar",
        },
        {
          sortable: false,
          text: "Descripción",
          value: "descripcionMostrar",
        },
        {
          sortable: false,
          text: "Categoría",
          value: "categoriaMostrar",
        },
      ],
      headers: [
        {
          sortable: false,
          text: "Imagen",
          value: "imagen",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "nombreMostrar",
        },
        {
          sortable: false,
          text: "Descripción",
          value: "descripcionMostrar",
        },
        // {
        //   sortable: false,
        //   text: "Precio",
        //   value: "",
        // },
        // {
        //   sortable: false,
        //   text: "Categoría",
        //   value: "categoriaMostrar",
        // },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
      itemMapeando: null,
      searchNeo: "",
      loadingNeo: false,
      loadingMapeo: false,
      selectedNeo: [],
      headersNeo: [
        {
          sortable: false,
          text: "Codigo",
          value: "Codigo",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "Nombre",
        },
        {
          sortable: false,
          text: "Tipo",
          value: "Tipo",
        },
      ],
    };
  },
  computed: {
    menusComputed() {
      return this.menus.map((m) => {
        return {
          ...m,
          nombreMostrar: this.mostrarIdioma(m.nombre),
          descripcionMostrar: this.mostrarIdioma(m.descripcion),
        };
      });
    },
    search: {
      get() {
        return this.$store.state.productos.busquedaMenu;
      },
      set(v) {
        this.$store.commit("productos/setBusquedaMenu", v);
      },
    },
    formTitle() {
      return this.isEdit ? "Editar Menu" : "Nuevo Menu";
    },

    ...mapState({
      //productos : (state) => state.productos.productosArray,
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      menus: (state) => state.productos.menus,
    }),
    ...mapGetters({
      // esCentralizadoMapeoNeo: "app/esCentralizadoMapeoNeo",
      isAdmin: "auth/isAdmin",
      negocio: "app/negocioGestObj",
      //productos: "productos/getProductosListado",
      //categoriasSelect: "categorias/getCategoriasSelect",
    }),

    subtitle() {
      return "Listado de menús de " + this.negocio.nombre;
    },

    menusOrden() {
      return this.menus.sort((a, b) =>
        a.orden > b.orden ? 1 : b.orden > a.orden ? -1 : 0
      );
    },
    ordenP: {
      get() {
        return this.menusOrden;
      },
      set(v) {
        var res = [];
        let _vm = this;
        v.forEach((e, i) => {
          let aux = {
            orden: i,
            id: e.id,
          };
          res.push(aux);
        });
        return this.$store
          .dispatch("productos/ordenarMenus", res)
          .then(() => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Menús ordenados",
            });
            _vm.getMenus();
          })
          .catch((e) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al ordenar menús",
            });
          });
      },
    },
  },
  watch: {
    dialogMapeo(val) {
      val || this.close();
    },
  },
  methods: {
    mostrarIdioma(str) {
      return mostrarIdioma(str);
    },
    reload() {
      this.getMenus();
    },
    goAdd() {
      let str = "/admin/gest/" + this.negocio.id + "/almacen/menus/form";
      this.$router.push(str);
    },
    goEdit(item) {
      let str =
        "/admin/gest/" + this.negocio.id + "/almacen/menus/form/" + item.id;
      this.$router.push(str);
    },
    goPrecios(item) {
      let str = "/admin/gest/" + this.negocio.id + "/almacen/menus/precios/";
      this.$router.push(str);
    },
    getMenus() {
      this.loading = true;
      let _vm = this;
      return this.$store.dispatch("productos/getMenus").finally(() => {
        _vm.loading = false;
      });
    },
    initNegocio() {
      let negocio = this.$route.params.negocio;
      this.$store.commit("app/setNegocioGest", negocio, { root: true });
    },

    deleteItem(item) {
      let r = confirm("¿Quieres eliminar el menu? (no se puede deshacer)");
      if (r) {
        this.loading = true;
        let _vm = this;
        this.$store
          .dispatch("productos/deleteMenu", item)
          .then((res) => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Menú eliminado",
            });
            _vm.getMenus();
          })
          .catch((error) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al eliminar",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    getColor(item) {
      return item.mapeoNeo ? "green" : "red";
    },
  },
  mounted() {
    let _vm = this;
    //this.initNegocio();
    this.getMenus();
    // this.categoria = this.categorias[0].value;
  },
};
</script>

<style>
</style>